export const WALLET_KEY = "WALLET_KEY";
export const WALLET_COINS = "WALLET_COINS";
export const SET_COINS = "SET_COINS";